import {config} from 'src/shared/config'

export const tagToUrl = (tag: string) => `${config.yaAuthProxy.host}/3.0/getimage?tag=${tag}&size_hint=9999`
